import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  CircularProgress,
  InputBase,
  InputAdornment,
  ClickAwayListener,
} from "@mui/material";
import { searchPlaceholder } from "../messages";
import "./search-bar.scss";
import CloseIcon from "@mui/icons-material/Close";

export const SearchBar = ({
  value,
  handleChange,
  handleFocus,
  handleClear,
  isLoading,
  placeHolder = searchPlaceholder,
  ...props
}) => {
  const searchbarInputElement = (
    <InputBase
      spellCheck="false"
      id="global-searchbox"
      autoComplete="off"
      value={value}
      className="global-search-input"
      placeholder={placeHolder}
      inputProps={{ "aria-label": placeHolder }}
      onChange={handleChange}
      onFocus={handleFocus}
      startAdornment={
        <>
          <InputAdornment className="global-search-icon" position="start">
            {isLoading ? (
              <CircularProgress className="icon-spin" />
            ) : (
              <SearchIcon />
            )}
          </InputAdornment>
          {value && (
            <CloseIcon className="clear-search-icon" onClick={handleClear} />
          )}
        </>
      }
      {...props}
    />
  );

  return (
    // <ClickAwayListener onClickAway={props?.handleClickAway}>
    <Box className="global-search-wrapper">
      {searchbarInputElement}
      {/* {showResultMenu && searchbarResultMenu} */}
    </Box>
    // </ClickAwayListener>
  );
};
